import { observer } from 'mobx-react-lite';
import { Container, LogoImgWrapper, LogoLink } from './header.styles';
import { VisuallyHidden } from '../../common/visually-hidden/visually-hidden.styles';
import {
  generateLocaleRoute,
  generateMyRoute,
} from '../../utils/uri/uri.utils';
import { getLogo, getLogoDescription } from './header.component';
import { useStore } from '../../stores/store';
import { AppRoute } from '../../constants/route';

interface Props {
  onClick?: () => void;
}

export const getLinkUrl = (hasMarketingPage: boolean) => {
  if (!hasMarketingPage) {
    return generateMyRoute(AppRoute.PARCEL_LIST);
  }

  return generateLocaleRoute();
};

const HeaderSimple = ({ onClick }: Props) => {
  const {
    navStore: { hasMarketingPage },
  } = useStore();

  return (
    <Container>
      <LogoImgWrapper>
        <LogoLink
          to={getLinkUrl(hasMarketingPage)}
          onClick={onClick}>
          <VisuallyHidden>{getLogoDescription()}</VisuallyHidden>
          {getLogo()}
        </LogoLink>
      </LogoImgWrapper>
    </Container>
  );
};

export default observer(HeaderSimple);
